import React from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
    House,
    Key,
    People,
    CreditCard,
    PersonBadge,
    Gear,
    FileEarmarkText,
    Wallet,
    CollectionPlay,
    CashStack
} from "react-bootstrap-icons";

// 👉 import your logo
import logo from "../../assets/logo.webp"; // adjust path

const menuItems = [
    { name: "Home", path: "/admin", icon: <House /> },
    { name: "Users", path: "/admin/users", icon: <People /> },
    { name: "Subscriptions", path: "/admin/subscriptions", icon: <CreditCard /> },
    { name: "Payment Orders", path: "/admin/payment-orders", icon: <CashStack /> },
    { name: "Activation Codes", path: "/admin/activation-codes", icon: <Key /> },
    { name: "Sale Agents", path: "/admin/sale-agents", icon: <PersonBadge /> },
    { name: "Team Expenses", path: "/admin/expenses", icon: <Wallet /> },
    { name: "Content", path: "/admin/content", icon: <CollectionPlay /> },
    { name: "App Settings", path: "/admin/settings", icon: <Gear /> },
    { name: "Logs", path: "/admin/logs", icon: <FileEarmarkText /> },
];

export default function Sidebar() {
    const location = useLocation();

    return (
        <div
            className="d-flex flex-column bg-dark text-white p-3"
            style={{ width: "240px", minHeight: "100vh" }}
        >
            {/* Header */}
            <div className="mb-3 text-center">
                <h5 className="fw-bold mb-1">English Trainer</h5>
                <small className="text-secondary">Dashboard</small>
            </div>

            {/* 🔥 Logo */}
            <div className="text-center mb-4">
                <Link to="/admin">
                    <div
                        style={{
                            width: "90px",
                            height: "90px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            margin: "0 auto",
                            border: "2px solid rgba(255,255,255,0.2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#1f1f1f",
                            cursor: "pointer"
                        }}
                    >
                        <img
                            src={logo}
                            alt="English Trainer Logo"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover"
                            }}
                        />
                    </div>
                </Link>
            </div>

            {/* Menu */}
            <Nav className="flex-column gap-2 mt-4">
                {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;

                    return (
                        <Nav.Link
                            as={Link}
                            to={item.path}
                            key={item.path}
                            className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${isActive ? "bg-primary text-white" : "text-white"
                                }`}
                            style={{ transition: "0.2s" }}
                        >
                            <span>{item.icon}</span>
                            <span>{item.name}</span>
                        </Nav.Link>
                    );
                })}
            </Nav>

            {/* Footer */}
            <div className="mt-auto pt-3 text-center text-secondary" style={{ fontSize: "12px" }}>
                © {new Date().getFullYear()}{" "}
                <Link to="/" className="text-decoration-none text-secondary">
                    karmantrener.com.tm
                </Link>
            </div>
        </div>
    );
}